import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ActivatedRoute } from '@angular/router';
import { WpBookingRequest } from '../wp-booking-request';
import { LoginService } from '../security/login.service';
import * as moment from 'moment';

@Component({
  selector: 'app-wp-booking-request-print',
  templateUrl: './wp-booking-request-print.component.html',
  styleUrls: ['./wp-booking-request-print.component.css']
})
export class WpBookingRequestPrintComponent implements OnInit {

  selectedRequest: WpBookingRequest | null = null;
  duration: number | null = null;
  studentIsAdult: boolean = false;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = false;
   }

  ngOnInit(): void {
    let requestId = parseInt(this.route.snapshot.paramMap.get("requestId")!);
    this.httpService.getWpBookingRequestById(requestId).subscribe(request => {
      this.selectedRequest = request;
      this.calculateDuration();
      this.selectedRequest.birthDate = moment(this.selectedRequest.birthDate);
      this.studentIsAdult = this.selectedRequest.age >= 18;
      request.startDay = moment(request.startDay);
      request.endDay = moment(request.endDay);
    });
  }

  calculateDuration(){
    let startMoment = moment(this.selectedRequest!.startDay);
    let endMoment = moment(this.selectedRequest!.endDay);
    this.duration = Math.ceil(endMoment.diff(startMoment, "days")/7);
  }

}
